<template>
  <ul class="menu-list">
    <li
      v-for="link in dataList"
      :key="link.id"
      @click="handleLink(link)"
      :class="getLinkClass(link)"
    >
      {{ link.linkName }}
    </li>
  </ul>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { isHttp } from '@/utils/validate'

import { list, updateClickCount } from '@/api/client/top/link'

const route = useRoute()
const router = useRouter()

const dataList = ref([])

/**
 * 获取数据
 */
async function getData() {
  const { data } = await list()
  dataList.value = data
}

function handleLink(link) {
  const url = link.linkUrl

  if (isHttp(url)) {
    if (link.linkType === 1) {
      // 当前页打开
      window.open(url)
    } else {
      // 新标签页打开
      window.open(url, '_target')
    }
  } else {
    if (link.linkType === 1) {
      // 当前页打开
      router.push(url)
    } else {
      // 新标签页打开
      const newUrl = router.resolve({
        path: url
      })
      window.open(newUrl.href, '_target')
    }
  }
  // 更新点击量
  updateClickCount(link.id)
}

/**
 * 获取链接类
 */
function getLinkClass(link) {
  return route.path === link.linkUrl ? 'title' : ''
}

getData()
</script>

<style lang="scss" scoped>
.menu-list {
  margin-right: 10px;
  float: right;
  list-style: none;
  cursor: pointer;
  li {
    float: left;
    padding: 0px 20px 12px 20px;
    font-size: 15px;
    color: #909399;
  }
  .title {
    color: black !important;
    font-weight: bold;
    border-bottom: 2px solid #409eff;
  }
}
</style>
